import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SendSmsResponse } from '../../models/intefaces/send-sms-response';
import { UserService } from '../user/user.service';
import { ValidSmsResponse } from '../../models/intefaces/valid-sms-response';
import { SuccessResponse } from '../../models/intefaces/success-response';
import { ProcessRequest } from '../../models/intefaces/process-request';
import { ValidSmsRequest } from '../../models/intefaces/valid-sms-request';
import { TranslationsService } from '../translations/translations.service';

const SendSMSRoute = '/api/v1/auth/sendSms';
const ValidSMSRoute = '/api/v1/auth/validSms';

@Injectable({
  providedIn: 'root',
})
export class SmsValidationService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly userService: UserService,
    private readonly translationsService: TranslationsService
  ) {}

  send(): Observable<SendSmsResponse> {
    return this.httpClient.post<SendSmsResponse>(this.getUrl(SendSMSRoute), this.getData());
  }

  private getUrl(endpoint: string): string {
    return `${this.translationsService.getTranslations().api_url}${endpoint}`;
  }

  validate(text: string): Observable<SuccessResponse> {
    const data: ValidSmsRequest = this.getValidSmsRequest(text);
    return this.httpClient.post<ValidSmsResponse>(this.getUrl(ValidSMSRoute), data);
  }

  private getData(): ProcessRequest {
    return {
      process_id: this.userService.getProcessId(),
    };
  }

  private getValidSmsRequest(text: string): ValidSmsRequest {
    const request = this.getData();
    return {
      process_id: request.process_id,
      sms: text,
      is_repatriation_accelerated: true,
    };
  }
}
